import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import alertcircleoutline from '@iconify/icons-eva/alert-circle-outline';
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Stack,
  TextField,
} from '@material-ui/core';

import Modal from 'react-bootstrap/Modal';
import "bootstrap/dist/css/bootstrap.min.css";
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import { Button as Button2 } from 'reactstrap';

import { addItem, getItem } from '../../services/LocaleStorage';

//notificacao
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import axios from "axios";
import functions from "../../../constants/serverFunctions";

// ----------------------------------------------------------------------

export default function ItemMoreMenu(props) {

  const token = getItem('token-assembleia-api');

  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const [show, setShow] = useState(false);
  const [show3, setShow3] = useState(false);
  const handleClose2 = () => setShow(false);
  const handleClose3 = () => setShow3(false);
  const handleShow = () => setShow(true);
  const handleShow3 = () => setShow3(true);

  const IMAGEM_PADRAO = "/static/illustrations/candidato/default3.png";

  const [imagemAtual, setImagemAtual] = useState(
    props.value.imagemCandidato || IMAGEM_PADRAO
  );


  <button
    type="button"
    onClick={(e) => {
      e.stopPropagation();

      formik.setFieldValue("imagem", null);
      fileInputRef.current.value = null;

      setImagemAtual(IMAGEM_PADRAO);
    }}
  >
    ×
  </button>



  const LoginSchema = Yup.object().shape({
    nome: Yup.string().required('campo obrigatória'),

  });

  const formik = useFormik({
    initialValues: {
      id: props.value.idCandidato,
      nome: props.value.candidato,
      cargo: props.value.cargo,
      descricao: props.value.descricaoCanditado,
      imagem: null

    },

    validationSchema: LoginSchema,
    //   onSubmit: async () => {

    //      try {

    //    // console.log(props.value)
    //    // console.log(values)

    //     ((props.value.candidato !== values.nome 

    //       && 

    //         axios.post(functions.candidato.ATUALIZA_CANDIDATO, 
    //           values,
    //           { headers: {"Authorization" : `${token}`} }
    //           )
    //         .then((response) => {
    //           toast.success('Candidato atualizado com sucesso!');
    //           window.location.reload(false);
    //         })

    //     ) ||

    //     (props.value.cargo !== values.cargo 

    //       && 

    //         axios.post(functions.candidato.ATUALIZA_CANDIDATO, 
    //           values,
    //           { headers: {"Authorization" : `${token}`} }
    //           )
    //         .then((response) => {
    //           toast.success('Candidato atualizado com sucesso!');
    //           window.location.reload(false);
    //         })

    //     ) ||

    //     (props.value.descricaoCanditado !== values.descricao 

    //       && 

    //         axios.post(functions.candidato.ATUALIZA_CANDIDATO, 
    //           values,
    //           { headers: {"Authorization" : `${token}`} })
    //         .then((response) => {
    //           toast.success('Candidato atualizado com sucesso!');
    //           window.location.reload(false);
    //         })

    //     ) ||

    //       (window.location.reload(false))

    //     )




    // } catch (error) {
    //    toast.error('Erro ao criar candidato');
    //  } finally {
    //    setSubmitting(false);
    //  }


    //   }


    onSubmit: async (values, { setSubmitting }) => {
      try {
        // console.log("testa-img-> ", props.value, values)
        // if (props.value.imagemCandidato == null && values.imagem == null) {
        //   console.log("testa- removeu imagem")
        // } else if (props.value.imagemCandidato != null && values.imagem == null) {
        //   console.log("testa- nao removeu e nao atualizou a imagem")
        // } else if (props.value.imagemCandidato != null && values.imagem != null) {
        //   console.log("testa - atualizou a imagem direto")
        // } else if (props.value.imagemCandidato == null && values.imagem != null) {
        //   console.log("testa- removeu e atualizou a imagem")
        // }



        const houveAlteracao =
          props.value.candidato !== values.nome ||
          props.value.cargo !== values.cargo ||
          props.value.descricaoCanditado !== values.descricao
          ;

        if (!houveAlteracao && props.value.imagemCandidato == null && values.imagem == null) {

          axios.post(functions.candidato.REMOVE_IMAGEM_CANDIDATO,
            { id: values.id },
            { headers: { "Authorization": `${token}` } })
            .then((response) => {
            })


        } else if (!houveAlteracao && !values.imagem) {
          toast.info("Nenhuma alteração realizada");
          return;
        }

        // ATUALIZA DADOS DO CANDIDATO
        let response = null;

        if (houveAlteracao) {
          response = await axios.post(
            functions.candidato.ATUALIZA_CANDIDATO,
            values,
            { headers: { Authorization: `${token}` } }
          );
        }

        // id pode vir do response ou do próprio values
        const idCandidato =
          response?.data?.id || values.id || props.value.idCandidato;

        // SE TIVER IMAGEM → FAZ UPLOAD
        if (values.imagem && idCandidato) {
          const formData = new FormData();
          formData.append("imagem", values.imagem);

          await axios.post(
            `${functions.candidato.UPLOADIMAGEMCANDIDATO}/${idCandidato}`,
            formData,
            {
              headers: {
                Authorization: `${token}`,
                "Content-Type": "multipart/form-data",
              },
            }
          );

        }

        toast.success("Candidato atualizado com sucesso!");
        window.location.reload(false);

      } catch (error) {
        console.error(error);
        toast.error("Erro ao atualizar candidato");
      } finally {
        setSubmitting(false);
      }
    }




  });


  //botao apagar item
  const apagarCandidato = (id) => {

    const token = getItem('token-assembleia-api');

    axios.delete(functions.candidato.EXCLUIR_POR_ID + "/" + id, { headers: { "Authorization": `${token}` } })
      .then((response) => {
        toast.success('Candidato apagada!');
        window.location.reload(false);
      });

  }



  const {
    errors,
    touched,
    values,
    isSubmitting,
    handleSubmit,
    getFieldProps
  } = formik;

  const fileInputRef = useRef(null);

  const imagemExibida = formik.values.imagem
    ? URL.createObjectURL(formik.values.imagem)
    : (props.value.imagemCandidato || IMAGEM_PADRAO);


  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClick={() => setIsOpen(false)}
      >

        <MenuItem sx={{ color: 'text.secondary' }} onClick={handleShow}>
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Editar candidato" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem sx={{ color: 'text.secondary' }} onClick={handleShow3}>
          <ListItemIcon>
            <Icon icon={trash2Outline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Apagar" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>


      </Menu>



      <Modal visible style={{ zIndex: 1200 }}
        show={show}
        onHide={handleClose2}
        backdrop="static"
        keyboard={false}
      >

        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>

            <Modal.Header style={{ justifyContent: 'center' }} >
              <Modal.Title>Editar Candidato</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflow: 'scroll' }}>

              <Stack spacing={3}>

                <div style={{ textAlign: "center" }}>
                  <input
                    ref={fileInputRef}
                    accept="image/png,image/jpeg,image/jpg"
                    type="file"
                    style={{ display: "none" }}
                    onChange={(event) => {
                      if (event.target.files && event.target.files[0]) {
                        formik.setFieldValue("imagem", event.target.files[0]);
                      }
                    }}
                  />

                  {/* IMAGEM (backend ou preview) */}
                  {(formik.values.imagem || props.value.imagemCandidato) && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        justifyContent: "center",
                        marginBottom: 10
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <img
                          src={
                            formik.values.imagem
                              ? URL.createObjectURL(formik.values.imagem)
                              : props.value.imagemCandidato
                          }
                          alt="Imagem do candidato"
                          onClick={() => fileInputRef.current.click()}
                          style={{
                            width: 150,
                            height: 150,
                            objectFit: "cover",
                            borderRadius: 8,
                            border: "1px solid #ccc",
                            cursor: "pointer"
                          }}
                        />

                        {/* OVERLAY */}
                        <div
                          onClick={() => fileInputRef.current.click()}
                          style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(0,0,0,0.45)",
                            borderRadius: 8,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            opacity: 0,
                            transition: "opacity .2s"
                          }}
                          className="image-overlay"
                        >
                          <Button2 type="button" color="light" size="sm">
                            Trocar
                          </Button2>
                        </div>

                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();

                            // remove imagem nova
                            formik.setFieldValue("imagem", null);

                            // limpa input
                            fileInputRef.current.value = null;

                            // força fallback para imagem padrão
                            props.value.imagemCandidato = null;
                          }}
                          style={{
                            position: 'absolute',
                            top: -8,
                            right: -8,
                            width: 26,
                            height: 26,
                            borderRadius: '50%',
                            border: 'none',
                            background: '#dc3545',
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer'
                          }}
                        >
                          ×
                        </button>

                      </div>

                      {/* BOTÃO AO LADO */}
                      <Button2
                        type="button"
                        color="secondary"
                        outline
                        onClick={() => fileInputRef.current.click()}
                      >
                        Trocar imagem
                      </Button2>
                    </div>
                  )}

                  {/* QUANDO NÃO TEM IMAGEM NENHUMA */}
                  {!formik.values.imagem && !props.value.imagemCandidato && (
                    <Button2
                      type="button"
                      color="primary"
                      outline
                      onClick={() => fileInputRef.current.click()}
                    >
                      Selecionar imagem
                    </Button2>
                  )}

                  {/* ERRO */}
                  {formik.touched.imagem && formik.errors.imagem && (
                    <div style={{ color: "#fc0019ff", marginTop: 6 }}>
                      {formik.errors.imagem}
                    </div>
                  )}
                </div>



                <TextField
                  id="nome"
                  variant="standard"
                  label="Nome do candidato*"
                  {...getFieldProps('nome')}
                  error={Boolean(touched.nome && errors.nome)}
                  helperText={touched.nome && errors.nome}
                />

                <TextField
                  style={{ marginTop: "10px" }}
                  id="cargo"
                  label="Cargo"
                  variant="standard"
                  {...getFieldProps('cargo')}
                  error={Boolean(touched.cargo && errors.cargo)}
                  helperText={touched.cargo && errors.cargo}
                />

                <br />


                <div class="form-group" style={{ marginTop: "10px" }}>
                  <label for="descricao">Descrição</label>
                  <textarea
                    class="form-control"
                    id="descricao"
                    rows="5"
                    {...getFieldProps('descricao')}
                  >
                  </textarea>
                </div>

                <br />
              </Stack>


            </Modal.Body>
            <Modal.Footer>
              <Button2 variant="secondary" onClick={handleClose2}>
                Cancelar
              </Button2>
              <Button2 type="submit" className="btn-success" loading={isSubmitting} variant="primary" >Salvar</Button2>
            </Modal.Footer>

          </Form>
        </FormikProvider>
      </Modal>



      <Modal visible style={{ zIndex: 1200 }}
        show={show3}
        onHide={handleClose3}
        backdrop="static"
        keyboard={false}
      >

        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>

            <Modal.Header style={{ justifyContent: 'center' }} >
              <Modal.Title>Excluir</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ overflow: 'scroll', textAlign: 'center' }}>


              <Stack spacing={3}>
                <div>
                  <Icon icon={alertcircleoutline} width={70} height={70} color="red" />
                </div>
                <br />
                <b>Essa ação não pode ser desfeita. Isso excluirá permanentemente seu recurso.</b>
                <br />

              </Stack>


            </Modal.Body>
            <Modal.Footer>
              <Button2 variant="secondary" onClick={handleClose3}>
                Cancelar
              </Button2>
              <Button2 className="btn-danger" variant="primary" onClick={(e) => apagarCandidato(values.id, e)}>Confirmar</Button2>
            </Modal.Footer>

          </Form>
        </FormikProvider>
      </Modal>



    </>
  );
}
